import { updateState } from "@angular-architects/ngrx-toolkit";
import { signalStoreFeature, withMethods } from "@ngrx/signals";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function withSetStateMethods<T extends object>(storeName: string, initialState: T) {
    return signalStoreFeature(
        withMethods((store) => {
            const methods: Record<string, (value: unknown) => void> = {};

            for (const key in initialState) {
                if (Object.prototype.hasOwnProperty.call(initialState, key)) {
                    const capitalizedKey = key.charAt(0).toUpperCase() + key.slice(1);
                    const methodName = `set${capitalizedKey}`;
                    const stateKey = key as keyof T;

                    methods[methodName] = (value) => {
                        updateState(store, `[${storeName}] ${methodName}`, { [stateKey]: value });
                    };
                }
            }

            return methods as {
                [K in keyof T as K extends string ? `set${Capitalize<K>}` : never]: (value: T[K]) => void;
            };
        })
    );
}
